module.exports = __webpack_public_path__ + "img/icon-team.fec9c488.png";